<template>
  <div class="content-7__linkbox">
    <div v-for="(tab, index) in trendTabbarMapping" :key="`tab-${index}`" class="content-7__linkbox__item">
      <div class="linkgroup">
        <div class="linkgroup__title"><span class="linkgroup__title__text">{{ tab.typeName }}</span></div>
        <div class="linkgroup__content">
          <a v-for="(item, itemIndex) in tab.list" :key="`item-${itemIndex}`" class="button-primary" href="" item.label="==}" :class="{'active':item.value === activePage}" @click.prevent="chooseRule(item.value)">
            <span class="button-primary__text">{{ item.label }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { trendTabbarMapping } from '@/utils/lhDesktopTabbarMapping'

export default {
  name: 'TrendTabbar',
  data() {
    return {
      trendTabbarMapping,
      activePage: 'KaiJiangHaoMa'
    }
  },
  mounted() {
    // 如果有帶 query 導到該玩法
    if (this.$route.query.category) {
      this.activePage = this.$route.query.category
      this.$emit('change-component', this.$route.query.category)
    } else {
      this.$emit('change-component', 'KaiJiangHaoMa')
    }
  },
  methods: {
    chooseRule(value) {
      this.activePage = value
      this.$emit('change-component', value)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
